const latinSup = {
    title: 'Latin Supplemental',
    characters: [
        {character: 'À', title: 'Latin Capital Letter A with grave'},
        {character: 'Á', title: 'Latin Capital letter A with acute'},
        {character: 'Â', title: 'Latin Capital letter A with circumflex'},
        {character: 'Ã', title: 'Latin Capital letter A with tilde'},
        {character: 'Ä', title: 'Latin Capital letter A with diaeresis'},
        {character: 'Å', title: 'Latin Capital letter A with ring above'},
        {character: 'Æ', title: 'Latin Capital letter Æ'},
        {character: 'Ç', title: 'Latin Capital letter C with cedilla'},
        {character: 'È', title: 'Latin Capital letter E with grave'},
        {character: 'É', title: 'Latin Capital letter E with acute'},
        {character: 'Ê', title: 'Latin Capital letter E with circumflex'},
        {character: 'Ë', title: 'Latin Capital letter E with diaeresis'},
        {character: 'Ì', title: 'Latin Capital letter I with grave'},
        {character: 'Í', title: 'Latin Capital letter I with acute'},
        {character: 'Î', title: 'Latin Capital letter I with circumflex'},
        {character: 'Ï', title: 'Latin Capital letter I with diaeresis'},
        {character: 'Ð', title: 'Latin Capital letter Eth'},
        {character: 'Ñ', title: 'Latin Capital letter N with tilde'},
        {character: 'Ò', title: 'Latin Capital letter O with grave'},
        {character: 'Ó', title: 'Latin Capital letter O with acute'},
        {character: 'Ô', title: 'Latin Capital letter O with circumflex'},
        {character: 'Õ', title: 'Latin Capital letter O with tilde'},
        {character: 'Ö', title: 'Latin Capital letter O with diaeresis'},
        {character: 'Ø', title: 'Latin Capital letter O with stroke'},
        {character: 'Ù', title: 'Latin Capital letter U with grave'},
        {character: 'Ú', title: 'Latin Capital letter U with acute'},
        {character: 'Û', title: 'Latin Capital Letter U with circumflex'},
        {character: 'Ü', title: 'Latin Capital Letter U with diaeresis'},
        {character: 'Ý', title: 'Latin Capital Letter Y with acute'},
        {character: 'Þ', title: 'Latin Capital Letter Thorn'},
        {character: 'ß', title: 'Latin Small Letter sharp S'},
        {character: 'à', title: 'Latin Small Letter A with grave'},
        {character: 'á', title: 'Latin Small Letter A with acute'},
        {character: 'â', title: 'Latin Small Letter A with circumflex'},
        {character: 'ã', title: 'Latin Small Letter A with tilde'},
        {character: 'ä', title: 'Latin Small Letter A with diaeresis'},
        {character: 'å', title: 'Latin Small Letter A with ring above'},
        {character: 'æ', title: 'Latin Small Letter Æ'},
        {character: 'ç', title: 'Latin Small Letter C with cedilla'},
        {character: 'è', title: 'Latin Small Letter E with grave'},
        {character: 'é', title: 'Latin Small Letter E with acute'},
        {character: 'ê', title: 'Latin Small Letter E with circumflex'},
        {character: 'ë', title: 'Latin Small Letter E with diaeresis'},
        {character: 'ì', title: 'Latin Small Letter I with grave'},
        {character: 'í', title: 'Latin Small Letter I with acute'},
        {character: 'î', title: 'Latin Small Letter I with circumflex'},
        {character: 'ï', title: 'Latin Small Letter I with diaeresis'},
        {character: 'ð', title: 'Latin Small Letter Eth'},
        {character: 'ñ', title: 'Latin Small Letter N with tilde'},
        {character: 'ò', title: 'Latin Small Letter O with grave'},
        {character: 'ó', title: 'Latin Small Letter O with acute'},
        {character: 'ô', title: 'Latin Small Letter O with circumflex'},
        {character: 'õ', title: 'Latin Small Letter O with tilde'},
        {character: 'ö', title: 'Latin Small Letter O with diaeresis'},
        {character: 'ø', title: 'Latin Small Letter O with stroke'},
        {character: 'ù', title: 'Latin Small Letter U with grave'},
        {character: 'ú', title: 'Latin Small Letter U with acute'},
        {character: 'û', title: 'Latin Small Letter U with circumflex'},
        {character: 'ü', title: 'Latin Small Letter U with diaeresis'},
        {character: 'ý', title: 'Latin Small Letter Y with acute'},
        {character: 'þ', title: 'Latin Small Letter Thorn'},
        {character: 'ÿ', title: 'Latin Small Letter Y with diaeresis'}
    ]
}
export default latinSup